import { render, staticRenderFns } from "./preExportCheckFooter.vue?vue&type=template&id=6460024e"
import script from "./preExportCheckFooter.vue?vue&type=script&lang=js"
export * from "./preExportCheckFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports